module.exports = __webpack_public_path__ + "img/GDQ-Associates-White.0bbe57cf.png";